import { cn } from "@/lib/utils";

// Shared premium look so new modules feel native to the existing hub.
export const PREMIUM_PANEL =
  "relative overflow-hidden rounded-3xl border border-white/[0.06] bg-gradient-to-br from-card/80 via-card/60 to-card/40 p-6 backdrop-blur-2xl shadow-[0_24px_60px_-30px_hsl(var(--primary)/0.45),inset_0_1px_0_0_hsl(var(--foreground)/0.05)]";

export function PanelGlow() {
  return (
    <>
      <div className="pointer-events-none absolute -top-24 -right-24 h-56 w-56 rounded-full bg-primary/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -left-16 h-48 w-48 rounded-full bg-secondary/10 blur-3xl" />
    </>
  );
}

const TONE_CLS: Record<string, string> = {
  building: "bg-primary/10 text-primary border-primary/30",
  ready: "bg-emerald-500/10 text-emerald-200 border-emerald-400/30",
  strong: "bg-emerald-500/10 text-emerald-200 border-emerald-400/30",
  growth: "bg-amber-500/10 text-amber-200 border-amber-400/30",
  neutral: "bg-muted/30 text-muted-foreground border-border/40",
  brand: "bg-primary/10 text-primary border-primary/25",
};

export function ToneChip({ tone, label }: { tone: keyof typeof TONE_CLS; label: string }) {
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-medium tracking-wide backdrop-blur-md", TONE_CLS[tone])}>
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-80" />
      {label}
    </span>
  );
}

export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  icon: Icon,
  right,
}: {
  eyebrow: string;
  title: string;
  subtitle?: string;
  icon?: React.ComponentType<{ className?: string }>;
  right?: React.ReactNode;
}) {
  return (
    <div className="mb-5 flex items-start justify-between gap-3">
      <div className="min-w-0">
        <p className="text-[10px] font-medium uppercase tracking-[0.18em] text-muted-foreground">{eyebrow}</p>
        <div className="mt-0.5 flex items-center gap-2.5">
          {Icon && (
            <span className="flex h-7 w-7 items-center justify-center rounded-xl bg-primary/10 text-primary ring-1 ring-primary/20">
              <Icon className="h-3.5 w-3.5" />
            </span>
          )}
          <h3 className="font-heading text-base font-semibold tracking-tight text-foreground sm:text-lg">{title}</h3>
        </div>
        {subtitle && <p className="mt-1 max-w-md text-xs leading-relaxed text-muted-foreground sm:text-sm">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

export function BuildingState({ message }: { message: string }) {
  return (
    <div className="relative flex flex-col items-center gap-2 rounded-2xl border border-white/[0.06] bg-gradient-to-b from-background/40 to-transparent p-8 text-center">
      <p className="max-w-md text-xs leading-relaxed text-muted-foreground">{message}</p>
    </div>
  );
}